module.exports = __webpack_public_path__ + "img/swiss-eco-bags-1.42cfaae8.jpg";